require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// /var/www/beauty-shop.ru/~/core-js/modules/es7.symbol.observable.js
// module id = 930
// module chunks = 32